import { Route, Routes } from "react-router-dom";

import { DetallesEquipo, Equipos } from "../pages";
import { NuevoEquipo } from "../pages/NuevoEquipo";

export const EquiposRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Equipos />} />
      <Route path="/nuevo" element={<NuevoEquipo />} />
      <Route path="/:id" element={<DetallesEquipo />} />
    </Routes>
  );
};
